import {BrowserRouter as Router} from 'react-router-dom'
import { GlobalStateProvider } from './utils/GlobalContext'
import Nav from '@ui/Nav'
import Routes from '@ui/Routes'
import Loader from '@components/loader/Loader'
import { CardsContextProvider } from '@utils/CardsContext'

function App() {
  return (
    <>  

        <Router>
          <GlobalStateProvider>
            <CardsContextProvider>
            <Nav/>
            <Routes/>
            <Loader/>
            </CardsContextProvider>
          </GlobalStateProvider>
        </Router>

    </>
  )
}
export default App
